import React, { forwardRef } from "react"

const cx = (...classes) => classes.filter(Boolean).join(" ")

export const Card = forwardRef(({ as: Component = "div", className, ...props }, ref) => (
  <Component ref={ref} className={cx("ui-card", className)} {...props} />
))

Card.displayName = "Card"

export const CardHeader = forwardRef(
  ({ as: Component = "div", className, split = false, ...props }, ref) => (
    <Component
      ref={ref}
      className={cx("ui-card__header", split && "ui-card__header--split", className)}
      {...props}
    />
  )
)

CardHeader.displayName = "CardHeader"

export const CardTitle = forwardRef(({ as: Component = "h3", className, ...props }, ref) => (
  <Component ref={ref} className={cx("ui-card__title", className)} {...props} />
))

CardTitle.displayName = "CardTitle"

export const CardDescription = forwardRef(
  ({ as: Component = "p", className, ...props }, ref) => (
    <Component ref={ref} className={cx("ui-card__description", className)} {...props} />
  )
)

CardDescription.displayName = "CardDescription"

export const CardContent = forwardRef(
  ({ as: Component = "div", className, ...props }, ref) => (
    <Component ref={ref} className={cx("ui-card__content", className)} {...props} />
  )
)

CardContent.displayName = "CardContent"

export const CardFooter = forwardRef(
  ({ as: Component = "div", className, ...props }, ref) => (
    <Component ref={ref} className={cx("ui-card__footer", className)} {...props} />
  )
)

CardFooter.displayName = "CardFooter"
